import { render, staticRenderFns } from "./water-activity-in-goa.vue?vue&type=template&id=2daf367d&scoped=true"
import script from "./water-activity-in-goa.vue?vue&type=script&lang=js"
export * from "./water-activity-in-goa.vue?vue&type=script&lang=js"
import style0 from "./water-activity-in-goa.vue?vue&type=style&index=0&id=2daf367d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daf367d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainCategoryCard: require('/workspace/components/MainCategoryCard.vue').default,PopularCategoryCard: require('/workspace/components/PopularCategoryCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
